// extracted by mini-css-extract-plugin
export var localeSelector = "_8n-0";